const getters = {
    token: state => state.user.token,
    userInfo: state => state.user.userInfo,
    sidebar: state => state.app.sidebar,
};
export default getters;